// Vuex
import Request from './request';
import consts from "@/consts.js";

async function fetchUnselect(data) {
  if (!data) data = {};
  return Request('get', "api/distribution-center-configs/get-un-delivery-districts", 
    Object.assign({},data,{
      itemsPerPage: consts.limitAll,
      limit: consts.limitAll,
    })
  );
}

async function fetchSelected(data) {
  if (!data) data = {};
  return Request('get', "api/distribution-center-configs/get-delivery-districts", 
    Object.assign({},data,{
      itemsPerPage: consts.limitAll,
      limit: consts.limitAll,
    })
  );
}

async function remove(data) {
    return Request('get', "api/distribution-center-configs/remove-district", data);
}

async function add(data) {
    return Request('get', "api/distribution-center-configs/add-district", data);
}

async function fetchDelivery(data) {
  if (!data) data = {};
  return Request('get', "api/distribution-center-configs/get-delivery-materials", 
    Object.assign({},data,{
      itemsPerPage: consts.limitAll,
      limit: consts.limitAll,
    })
  );
}

async function fetchUndelivery(data) {
  if (!data) data = {};
  return Request('get', "api/distribution-center-configs/get-un-delivery-materials", 
    Object.assign({},data,{
      itemsPerPage: consts.limitAll,
      limit: consts.limitAll,
    })
  );
}

async function removeMaterial(data) {
    return Request('get', "api/distribution-center-configs/remove-distribution-materials", data);
}

async function addMaterial(data) {
    return Request('get', "api/distribution-center-configs/add-distribution-materials", data);
}

export default {
    fetchUnselect,
    fetchSelected,
    remove,
    add,
    fetchDelivery,
    fetchUndelivery,
    removeMaterial,
    addMaterial,
};